/*!
 * Copyright (c) REWE Digital GmbH
 */
import { h, Host } from "@stencil/core";
import { container, ProductSearchService, } from "@rdss/client";
/**
 * VX Product Tile.
 */
export class VxSearch {
    constructor() {
        /**
         * Perform search with filter and pagination parameters.
         */
        this.performSearch = async (term) => {
            this.isSearching = true;
            const query = {
                search: {
                    term: term,
                },
                sort: this.sort,
                translations: [
                    'frontend/detail/product-variants',
                ],
                pagination: this.pagination,
                embed: ['products', 'brandTopSellerProducts', 'brandSuggestions', 'translations'],
            };
            return this.productSearchService.find(query)
                .then(({ pagination, _embedded }) => {
                this.pagination = pagination;
                this.products = _embedded.products;
                // FixMe: Use correct typing here (finalize typing for BrandSuggestion in zr-search-form.tsx)
                this.brandSuggestions = _embedded.brandSuggestions;
                this.brandTopSellerProducts = _embedded.brandTopSellerProducts;
            })
                .catch(e => console.debug(e))
                .finally(() => {
                this.isSearching = false;
            });
        };
        this.productSearchService = container.resolve(ProductSearchService);
        this.searchForm = undefined;
        this.searchAction = undefined;
        this.sort = undefined;
        this.pagination = { page: 1, objectsPerPage: 5 };
        this.products = undefined;
        this.brandTopSellerProducts = undefined;
        this.brandSuggestions = undefined;
        this.innerFilter = {};
        this.isSearching = false;
        this.userSearches = this.getUserSearches();
    }
    /**
     * The event listener for pagination page select events.
     */
    async handleSearchKeyUp(event) {
        if (event.detail.value.trim().length > 2) {
            await this.performSearch(event.detail.value);
        }
    }
    /**
     * Read user searches from localStorage.
     */
    getUserSearches() {
        const userSearches = localStorage.getItem('userSearches')
            ? JSON.parse(localStorage.getItem('userSearches')) : [];
        return Array.isArray(userSearches) ? userSearches.filter(item => typeof item === 'string') : [];
    }
    /**
     * Set user searches to localStorage.
     */
    async setUserSearches({ detail }) {
        if (detail.value) {
            const search = detail.value;
            let userSearches = this.getUserSearches().filter(s => s !== search);
            userSearches.unshift(search);
            userSearches = userSearches.slice(0, 5);
            localStorage.setItem('userSearches', JSON.stringify(userSearches));
            this.userSearches = userSearches;
        }
    }
    /**
     * Renders the component.
     */
    render() {
        // This is needed, because stencil cannot render strings.
        const SearchFormComponent = this.searchForm;
        return (h(Host, { key: 'd3506cac6055fb3be0f958a2fc10896618d0e5b1' }, h(SearchFormComponent, { key: '0aa45626915a1e4b9795b5dbcda797b585bbf901', productSuggestions: this.products, brandTopSellerProducts: this.brandTopSellerProducts, brandSuggestions: this.brandSuggestions, action: this.searchAction, isSearching: this.isSearching, totalResults: this.pagination.objectCount, userSearches: this.userSearches })));
    }
    static get is() { return "vx-search"; }
    static get encapsulation() { return "scoped"; }
    static get originalStyleUrls() {
        return {
            "$": ["vx-search.scss"]
        };
    }
    static get styleUrls() {
        return {
            "$": ["vx-search.css"]
        };
    }
    static get properties() {
        return {
            "productSearchService": {
                "type": "unknown",
                "mutable": false,
                "complexType": {
                    "original": "ProductSearchService",
                    "resolved": "ProductSearchService",
                    "references": {
                        "ProductSearchService": {
                            "location": "import",
                            "path": "@rdss/client",
                            "id": "../client/dist/index.d.ts::ProductSearchService"
                        }
                    }
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "Search service ref."
                },
                "defaultValue": "container.resolve(ProductSearchService)"
            },
            "searchForm": {
                "type": "string",
                "mutable": false,
                "complexType": {
                    "original": "'zr-search-form' | 'wf-search-form'",
                    "resolved": "\"wf-search-form\" | \"zr-search-form\"",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "Search Form component to use."
                },
                "attribute": "search-form",
                "reflect": false
            },
            "searchAction": {
                "type": "string",
                "mutable": false,
                "complexType": {
                    "original": "string",
                    "resolved": "string",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "Search action string."
                },
                "attribute": "search-action",
                "reflect": false
            },
            "sort": {
                "type": "number",
                "mutable": true,
                "complexType": {
                    "original": "number",
                    "resolved": "number",
                    "references": {}
                },
                "required": false,
                "optional": true,
                "docs": {
                    "tags": [],
                    "text": "The sorting query parameter. If not specified by the user we let the\nbackend decide which sorting to use as the default."
                },
                "attribute": "sort",
                "reflect": false
            }
        };
    }
    static get states() {
        return {
            "pagination": {},
            "products": {},
            "brandTopSellerProducts": {},
            "brandSuggestions": {},
            "innerFilter": {},
            "isSearching": {},
            "userSearches": {}
        };
    }
    static get listeners() {
        return [{
                "name": "searchInputChange",
                "method": "handleSearchKeyUp",
                "target": undefined,
                "capture": false,
                "passive": false
            }, {
                "name": "userSearchSuccess",
                "method": "setUserSearches",
                "target": "window",
                "capture": false,
                "passive": false
            }];
    }
}
//# sourceMappingURL=vx-search.js.map
